// src/App.jsx — COMPLETE, all routes wired
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { LanguageProvider } from "./context/LanguagesContext";
import { CartProvider, useCart } from "./context/CartContext";
import { ProtectedRoute, AdminRoute } from "./components/common/ProtectedRoute";
import BottomNav from "./components/common/BottomNav";

import Home from "./pages/Home";
import Store from "./pages/Store";
import GameDetail from "./pages/GameDetail";
import Login from "./pages/Login";
import Register from "./pages/Register";
import HowToUse from "./pages/HowToUse";
import Checkout from "./pages/Checkout";
import OrderSuccess from "./pages/OrderSuccess";
import MyOrders from "./pages/MyOrders";
import ChatPage from "./pages/ChatPage";
import Cart from "./pages/Cart";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Profile from "./pages/Profile";  

import AdminLayout from "./admin/AdminLayout";
import Dashboard from "./admin/Dashboard";
import ManageGames from "./admin/ManageGames";
import ManageStock from "./admin/ManageStock";
import AdminOrders from "./admin/Orders";
import AdminChats from "./admin/AdminChats";
import Settings from "./admin/Settings";
import Customers from "./admin/Customers";

function AppInner() {
  const { pathname } = useLocation();
  const { cartCount } = useCart();
  const isAdmin = pathname.startsWith("/admin");

  return (
    <>
      <Routes>
        {/* ── Public Routes ───────────────────────────────────────────── */}
        <Route path="/" element={<Home />} />
        <Route path="/store" element={<Store />} />
        <Route path="/game/:gameId" element={<GameDetail />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/how-to-use" element={<HowToUse />} />
        <Route path="/cart" element={<Cart />} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

        <Route path="/checkout/:gameId" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
        <Route path="/order-success/:orderId" element={<ProtectedRoute><OrderSuccess /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><MyOrders /></ProtectedRoute>} />
        <Route path="/orders/:orderId/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />

        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />

        {/* ── Admin Routes ─────────────────────────────────────────────── */}
        <Route path="/admin" element={<AdminRoute><AdminLayout /></AdminRoute>}>
          <Route index element={<Dashboard />} />
          <Route path="games" element={<ManageGames />} />
          <Route path="stock" element={<ManageStock />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="customers" element={<Customers />} />
          <Route path="chats" element={<AdminChats />} />
          <Route path="settings" element={<Settings />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      {!isAdmin && !pathname.startsWith("/game/") && <BottomNav cartCount={cartCount} />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <CartProvider>
            <AppInner />
          </CartProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}